import React, { createContext, useContext, useEffect, useState } from "react";
import { detectCurrency, formatPrice as fmt } from "@/lib/currency";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";

const CurrencyContext = createContext(null);

export const CurrencyProvider = ({ children }) => {
  const { user } = useAuth();
  const { lang } = useLang();
  const [currency, setCurrencyState] = useState(detectCurrency());

  // Sync from user profile when logged in
  useEffect(() => {
    if (user?.currency && user.currency !== currency) {
      setCurrencyState(user.currency);
      try { localStorage.setItem("so_currency", user.currency); } catch (e) { /* ignore */ }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.currency]);

  const setCurrency = (c) => {
    setCurrencyState(c);
    try { localStorage.setItem("so_currency", c); } catch (e) { /* ignore */ }
  };

  const formatPrice = (amount) => fmt(amount, currency, lang);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, formatPrice }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
